import React, { useEffect, useState } from 'react';

import { Button, ScrollBar, Table, WrapperFlex } from '@unimed-fesp/components';

import { BsPlus } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as WebhookEventIntegrationActions } from '../../../store/ducks/webhookEventIntegration';
import { Creators as WebhookIntegrationActions } from '../../../store/ducks/webhookIntegration';
import FadeIn from '../../atoms/FadeIn';

import ModalCadastarWebhookEvent from '../ModalCadastarWebhookEvent';
import ModalCancelAction from '../ModalCancelAction';
import ModalWebhookEventosHeaders from '../ModalWebhookEventosHeaders';
import TableCadastroWebhookEventsHeader from '../TableCadastroWebhookEventsHeader';
import TableCadastroWebHookEventBody from './TableCadastroWebHookEventBody';
import TableCadastroWebHookHeader from './TableCadastroWebHookHeader';

const TableCadastroWebhookEvents = ({ webhookId }) => {
  const dispatch = useDispatch();

  const [isEditarModal, setIsEditarModal] = useState(false);
  const [openModalCadastrarEvento, setOpenModalCadastrarEvento] =
    useState(false);
  const [openModalEventoHeader, setOpenModalEventoHeader] = useState({
    isOpen: false,
    eventId: '',
  });
  const [openModalDeletarEvento, setOpenModalDeletarEvento] = useState({
    isOpen: false,
    eventId: '',
  });

  const {
    getWebhookEventList,
    putWebhookEventIntegration,
    postWebhookEvent,
    deleteWebhookEventIntegration,
  } = useSelector((state) => state.webhookEventIntegration);
  const headers = [
    {
      id: 2,
      title: 'URL',
      maxWidth: '200',
      minWidth: '200',
    },
    {
      id: 3,
      title: 'Evento',
      maxWidth: '200',
      minWidth: '200',
    },
    {
      id: 4,
      title: 'Data Criação',
      maxWidth: '120',
      minWidth: '120',
    },
    {
      id: 5,
      title: 'Criado por',
      maxWidth: '120',
      minWidth: '120',
    },
    {
      id: 7,
      title: '',
      maxWidth: '150',
      minWidth: '150',
    },
  ];

  const deletarWebhookEvent = (webhookEventId) => {
    dispatch(
      WebhookEventIntegrationActions.deleteWebhookEventIntegrationRequest(
        webhookEventId
      )
    );
    setOpenModalDeletarEvento({
      isOpen: false,
      eventId: '',
    });
  };

  useEffect(() => {
    if (
      (!postWebhookEvent.loading && postWebhookEvent.success) ||
      (!putWebhookEventIntegration.loading &&
        putWebhookEventIntegration.success) ||
      (!deleteWebhookEventIntegration.loading &&
        deleteWebhookEventIntegration.success)
    ) {
      dispatch(
        WebhookEventIntegrationActions.getWebhookEventsListRequest(webhookId)
      );

      dispatch(
        WebhookEventIntegrationActions.postWebhookEventIntegrationResponse(
          {},
          false
        )
      );
      dispatch(
        WebhookEventIntegrationActions.putWebhookEventIntegrationResponse(
          {},
          false
        )
      );
      dispatch(
        WebhookEventIntegrationActions.deleteWebhookEventIntegrationResponse(
          {},
          false
        )
      );
    }
  }, [
    postWebhookEvent.success,
    putWebhookEventIntegration.success,
    deleteWebhookEventIntegration.success,
  ]);

  useEffect(() => {
    if (openModalCadastrarEvento) {
      dispatch(WebhookIntegrationActions.getWebhookListEventsRequest());
    }
  }, [openModalCadastrarEvento]);

  useEffect(() => {
    dispatch(
      WebhookEventIntegrationActions.getWebhookEventsListRequest(webhookId)
    );
  }, []);

  return (
    <>
      <WrapperFlex justifyEnd fullWidth>
        <Button
          tipo="primary"
          paddingTop={10}
          paddingRight={10}
          paddingBottom={10}
          paddingLeft={10}
          justifySpaceBetween
          alignCenter
          width={138}
          type="button"
          font="16px unimed_slabregular"
          onClick={() => setOpenModalCadastrarEvento(true)}
          data-testid="btn-add-contratante"
        >
          <BsPlus color="#FFFF" size="20" />
          Novo Evento
        </Button>
      </WrapperFlex>
      <ScrollBar height={500} width={1000}>
        <FadeIn>
          <Table head={<TableCadastroWebHookHeader headers={headers} />}>
            <TableCadastroWebHookEventBody
              setIsEditarModal={setIsEditarModal}
              setOpenModalCadastrarEvento={setOpenModalCadastrarEvento}
              setOpenModalDeletarEvento={setOpenModalDeletarEvento}
              openModalHeaders={setOpenModalEventoHeader}
            />
          </Table>
        </FadeIn>
      </ScrollBar>
      <ModalCadastarWebhookEvent
        isOpen={openModalCadastrarEvento}
        isEditar={isEditarModal}
        onClick={() => setOpenModalCadastrarEvento(false)}
        setIsEditarModal={setIsEditarModal}
      />
      <ModalCancelAction
        isOpen={openModalDeletarEvento.isOpen}
        onClickOk={() => deletarWebhookEvent(openModalDeletarEvento.eventId)}
        onClick={() =>
          setOpenModalDeletarEvento({
            isOpen: false,
            eventId: '',
          })
        }
        text="O Evento será excluído."
        textHeader="Excluir Evento"
        loading={getWebhookEventList.loading}
      />
      <ModalWebhookEventosHeaders
        isOpen={openModalEventoHeader.isOpen}
        onCloseModal={() =>
          setOpenModalEventoHeader({
            isOpen: false,
            eventId: '',
          })
        }
        titleModal="Headers eventos"
        BodyModal={
          <TableCadastroWebhookEventsHeader
            webhookEventId={openModalEventoHeader.eventId}
          />
        }
      />
    </>
  );
};

export default TableCadastroWebhookEvents;
